import React from 'react'
import Filters from 'Features/Filters'

const defaultFilters = { currentTab: 'ActiveDirectory', customers: 'All', customersStatus: 'All', regions: 'All', platformTypes: 'All' }

const SoftwareFilters = ({ filters, filterOptions, changeFilters, className }) => (
  <Filters {...{ filters, options: filterOptions, onChange: changeFilters, className }}>
    <Filters.Select {...{ filterName: 'customers' }} />
    <Filters.Select {...{ filterName: 'customersStatus', label: 'Customer status' }} />
    <Filters.Select {...{ filterName: 'regions', label: 'Customer Regions' }} />
    <Filters.Select {...{ filterName: 'platformTypes', label: 'Platform Type' }} />
  </Filters>
)

export { SoftwareFilters, defaultFilters }
